/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import i18n from '../../i18n/DashboardBundle.properties';
import dashboardComponentTypes from '../enum/dashboardComponentTypes';

var titleByType = {};
var baseTitle = i18n['dashboard.base.dialog.properties.title'];

titleByType[dashboardComponentTypes.WEB_PAGE_VIEW] = i18n['dashboard.component.web.page.view.add.component.dialog.title'];
titleByType[dashboardComponentTypes.FREE_TEXT] = i18n['dashboard.component.text.add.component.dialog.title'];
titleByType[dashboardComponentTypes.IMAGE] = i18n['dashboard.component.image.add.component.dialog.title'];
titleByType[dashboardComponentTypes.CROSSTAB] = i18n['dashboard.component.crosstab.save.title'];
titleByType[dashboardComponentTypes.TABLE] = i18n['dashboard.component.table.save.title'];
titleByType[dashboardComponentTypes.CHART] = i18n['dashboard.component.chart.save.title'];
titleByType[dashboardComponentTypes.ICHART] = i18n['dashboard.component.ichart.save.title'];

export default function (model) {
    var type;
    var title = (type = model.get('type')) in titleByType ? titleByType[type] : baseTitle;
    return title;
}